import location from './location';
import steps from './steps';
import company from './company';
import creative from './creative';
import payment from './payment';

// Adding missing translations that weren't included in the imported modules
const additionalTranslations = {
  // Campaign types
  standard: "حملة قياسية",
  premium: "حملة متميزة",
  enterprise: "حملة للشركات",
  
  // Campaign creation
  newCampaign: "أطلق حملتك",
  startFreshCampaign: "عزز تواجد علامتك التجارية",
  createCampaignCard: "إعلانات محددة الأهداف تحقق عائدًا على الاستثمار. استهدف الجمهور المناسب وعزز التحويلات من خلال منصتنا الرقمية الاستراتيجية.",
  createCampaign: "إنشاء حملة",
  
  // Campaign name
  campaignName: "اسم الحملة",
  enterCampaignName: "أدخل اسم الحملة",
  campaignNameHelp: "اختر اسمًا وصفيًا لتحديد حملتك بسهولة",
  nameCampaign: "تسمية حملتك الإعلانية",
  nameCampaignDescription: "قدم معرفًا فريدًا لمبادرتك التسويقية",
  
  // Campaign fields
  campaignTitle: "عنوان الحملة",
  campaignDescription: "وصف الحملة",
  campaignBudget: "تخصيص الميزانية",
  campaignStart: "تاريخ البدء",
  campaignEnd: "تاريخ الانتهاء",
  
  // Campaign statuses
  draft: "مسودة",
  pending: "في انتظار الموافقة",
  active: "نشطة",
  completed: "مكتملة",
  cancelled: "ملغاة",
  
  // Campaign metrics
  impressions: "المشاهدات",
  reach: "الوصول للجمهور",
  engagement: "معدل التفاعل",
  conversion: "معدل التحويل",
  roi: "العائد على الاستثمار",
  
  // Drafts section
  savedDrafts: "الحملات المحفوظة",
  noDrafts: "لم يتم العثور على حملات محفوظة",
  createYourFirst: "إنشاء أول حملة لك",
  lastEdited: "آخر تعديل",
  actions: "الإجراءات",
  viewAll: "عرض جميع الحملات",
  loading: "جاري تحميل الحملات...",

  // Draft resume section
  resumeDraft: "متابعة حملتك الإعلانية",
  continuePreviousDraft: "استكمال الحملات المحفوظة مسبقًا",
  viewAllDrafts: "عرض جميع الحملات المحفوظة",
  noDraftsFound: "لا توجد حملات قيد التنفيذ",
  loadingDrafts: "جاري تحميل حملاتك...",
  draftDeleted: "تم إزالة الحملة",
  draftDeletedSuccess: "تمت إزالة الحملة بنجاح",
  errorDeletingDraft: "خطأ في الإزالة",
  problemDeletingDraft: "حدثت مشكلة أثناء إزالة حملتك",
  confirmDeleteDraft: "تأكيد الإزالة",
  cancel: "إلغاء",
  delete: "إزالة",
  
  // Client dashboard section
  clientDashboard: "لوحة تحكم العميل",
  manageYourCampaigns: "مراقبة وإدارة حملاتك النشطة",
  viewCampaignPerformance: "الوصول إلى التحليلات، وتتبع مؤشرات الأداء، وتحسين جهود التسويق من خلال لوحة التحكم الشاملة.",
  accessDashboard: "الوصول إلى لوحة التحكم",

  // Step wizard descriptions
  enterAccountInfoDesc: "أدخل معلومات حسابك",
  selectLocationDesc: "اختر مواقع حملتك",
  selectDurationDesc: "حدد المدة التي ترغب في تشغيل حملتك خلالها",
  uploadCreativesDesc: "قم بتحميل الأصول الإبداعية لحملتك",
  reviewCampaignDesc: "مراجعة تفاصيل حملتك",

  // Saving
  saving: "جاريٍ الحفظ...",
  startCampaign: "بدء الحملة",
  
  // Dashboard
  campaignDashboard: "لوحة تحكم الحملات",
};

export default {
  ...location,
  ...steps,
  ...company,
  ...creative,
  ...payment,
  ...additionalTranslations,
} as const;